import styled from '@emotion/styled';

import SkeletonLoading from '../../../../shared/components/Loading/SkeletonLoading';

const Title = styled.div`
  width: 100px;
  padding: 23px 0 20px;
  margin: 0 auto;
`;

const TitleSearch = styled.div`
  width: 400px;
  margin: 0 auto;
  padding: 15px 0 24px;
`;

const MenuList = styled.div`
  padding: 23px 0 20px;
`;

const ListAbility = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 18px 0 16px;
`;

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  width: 1050px;
`;

const Product = styled.div`
  flex: 0 0 338px;
  height: 664px;
`;

const Content = styled.div`
  padding-top: 14px;
`;

const Item = styled.div`
  padding-bottom: 8px;
`;

function LoadingListItem() {
  return (
    <>
      <Product>
        <SkeletonLoading width={338} height={435} />
        <Content>
          <Item>
            <SkeletonLoading width={338} height={23} />
          </Item>
          <Item>
            <SkeletonLoading width={338} height={23} />
          </Item>
          <Item>
            <SkeletonLoading width={169} height={23} />
          </Item>
        </Content>
      </Product>
    </>
  );
}

export function LoadingList() {
  return (
    <>
      <Title>
        <SkeletonLoading width={100} height={35} />
      </Title>
      <MenuList>
        <SkeletonLoading width={1050} height={50} />
      </MenuList>
      <ListAbility>
        <SkeletonLoading width={50} height={24} />
        <SkeletonLoading width={375} height={24} />
      </ListAbility>
      <Inner>
        <LoadingListItem />
        <LoadingListItem />
        <LoadingListItem />
      </Inner>
    </>
  );
}

export function LoadingSearch() {
  return (
    <>
      <TitleSearch>
        <SkeletonLoading width={400} height={50} />
      </TitleSearch>
      <ListAbility>
        <SkeletonLoading width={50} height={24} />
        <SkeletonLoading width={375} height={24} />
      </ListAbility>
      <Inner>
        <LoadingListItem />
        <LoadingListItem />
        <LoadingListItem />
      </Inner>
    </>
  );
}
